import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <h2 className="footer-title">
        let’s <br /> connect!
      </h2>

      <div className="footer-links">

        <a
          href="mailto:contact.maisaa@gmail.com"
          className="footer-link"
        >
          email
        </a>

        <a
          href="https://github.com/mxisaa"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link"
        >
          github
        </a>
      </div>

      <p className="footer-credit">
        doodled, designed & developed by <span>maisaa</span>
      </p>
    </footer>
  );
};

export default Footer;
